import { graphql } from 'gql/generated'

export const CHANGE_BUSINESS_CUSTOMER_BUSINESS_CLIENT = graphql(`
  mutation ChangeBusinessCustomerBusinessClient($input: ChangeBusinessCustomerBusinessClientInput!) {
    changeBusinessCustomerBusinessClient(input: $input)
  }
`)
